module.exports = __webpack_public_path__ + "img/mts.bbedf7df.svg";